<template>
  <div class="iframe-container">
    <div class="draggable" v-draggable :style="{ top: y + 'px', left: x + 'px' }">
      <el-button  circle @click="dialogTableShow" class="btn_ball" v-if="showBall">
        <img :src="require('@/assets/icon.png')" alt="button image" style=" width: 37px; height: 34px;">
      </el-button>
    </div>
    <div>
        <el-dialog class="custom-dialog"  :visible.sync="dialogTableVisible" :width=dialogWidth :close-on-click-modal=false :show-close="false" @open="handleOpen" @close="handleClose">
          <div @click="dialogTableVisible=false" class="close_btn">
            <img :src="require('@/assets/close.png')" alt="button image">
          </div>
          <el-row>
            <el-col :span="24">
              <div>
                <el-avatar :src="require('@/assets/avatar.png')"></el-avatar>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg_list" justify="center">
            <el-col :span="12"><div class="grid-content bg-purple">账号：{{getUserName}}</div></el-col>
            <el-col :span="4"><div class="grid-content bg-purple-light"></div></el-col>
          </el-row>
          <el-row type="flex" class="row-bg_list" justify="center">
            <el-col :span="8">
              <el-button type="primary"  size="small"  plain @click="BindRealNameClick(true)">实名认证</el-button>
            </el-col>
            <el-col :span="8">
              <el-button type="primary"  size="small" plain @click="BindPassClick(true)">修改密码</el-button>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg_list" justify="center">
            <el-col :span="8">
              <el-button type="primary"  size="small"  plain @click="BindPhoneClick(true)">绑定手机</el-button>
            </el-col>
            <el-col :span="8" >
              <el-button type="primary"  size="small" plain @click="QuitClick()">退出登录</el-button>
            </el-col>
          </el-row>
          <el-row type="flex" class="row-bg_list">
            <el-col :span="24"><div class="grid-content bg-purple">联系客服QQ：888888</div></el-col>
          </el-row>
          <el-row type="flex" class="row-bg_list">
            <el-col :span="24"> <el-button type="primary"  size="small" plain @click="SetUpQQ()">快捷联系客服</el-button></el-col>
          </el-row>
          <el-row type="flex" class="row-bg_list">
            <el-col :span="24"><div class="grid-content bg-purple">客服工作时间：9：00-12：00</div></el-col>
          </el-row>
        </el-dialog>
      <div>
        <BindPhone :show="bind_phone_open" @child-phone="BindPhoneClick"></BindPhone>
      </div>
      <div>
        <RealName :show="bind_real_open" @child-real="BindRealNameClick"></RealName>
      </div>
      <div>
        <ResetPass :show="bind_pass_open" @child-pass="BindPassClick"></ResetPass>
      </div>
    </div>
    <div style="height: 85%">
          <iframe
        :src="iframeSrc"
        ref="myIframe"
        width="100%"
        height="100%"
        frameborder="0"
        allowfullscreen
    ></iframe>
    </div>
    <div class="foot" style="height: 13%;background-color: white">
        <p class="text-center">
            <a href="#" target="_blank"><img src="https://www.txitech.com/templets/lite/images/wenhuajingying.png" width="48" height="48"></a>
            广州雨橙科技有限公司 Copyright 2016-2024 rainorange.cn All Rights Reserved.
            <a style="color: #989898;"  href="http://www.miitbeian.gov.cn/" target="_blank">备案号</a> <a style="color: #989898;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2024230225号-1</a>
        </p>
        <p class="text-center" style="background-color: white;">抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
    </div>
  </div>
</template>

<script>
import BindPhone from "@/components/ball/BindPhone.vue"
import RealName from "@/components/ball/RealName.vue"
import ResetPass from "@/components/ball/ResetPass.vue"
import {globalStorage} from "@/util/tool";
export default {
  name: 'IframeComponent',
  components: {BindPhone,RealName,ResetPass},
  data() {
    return {
      moveMouser:false,
      showBall:true,
      bind_phone_open:false,
      bind_real_open:false,
      bind_pass_open:false,
      dialogWidth: '50%', // 初始宽度
      dialogTableVisible: false,
      x: 10, // 元素的x轴位置
      y: 0, // 元素的y轴位置
      margin: 10, // 保证元素距离视口的最小边距
    };
  },
  directives: {
    draggable: {
      bind(el, binding, vnode) {
        // let posX = 0, posY = 0, mouseX = 0, mouseY = 0;
        let posX = 0, posY = 0, startX = 0, startY = 0;
        // const margin = 10; // 距离边框的最小间距
        el.style.position = 'absolute'; // 保证元素是绝对定位

        // 当鼠标按下时触发
        const margin = vnode.context.margin;
        const elementWidth =40;  // 获取元素的宽度
        const elementHeight =40; // 获取元素的高度
        console.log(elementWidth,elementHeight)

        el.onmousedown = function (event) {
          event.preventDefault();
          startX = event.clientX;
          startY = event.clientY;
          document.onmousemove = onMouseMove;
          document.onmouseup = onMouseUp;
        };

        // 处理触摸开始事件
        el.ontouchstart = function (event) {
          if (event.touches.length === 1) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            document.ontouchmove = onTouchMove;
            document.ontouchend = onTouchEnd;
          }
        };

        el.onmouseleave = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };


        // 获取视口宽高并确保元素不会超出边界
        function checkBounds() {
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;

          // 限制元素的 `x` 坐标在视口范围内
          vnode.context.x = Math.max(margin, Math.min(vnode.context.x, viewportWidth - elementWidth - margin));

          // 限制元素的 `y` 坐标在视口范围内
          vnode.context.y = Math.max(margin, Math.min(vnode.context.y, viewportHeight - elementHeight - margin));
        }
        // 鼠标移动事件处理
        function onMouseMove(event) {
          posX = startX - event.clientX;
          posY = startY - event.clientY;
          startX = event.clientX;
          startY = event.clientY;
          vnode.context.x -= posX;
          vnode.context.y -= posY;
          vnode.context.moveMouser=true
          checkBounds(); // 每次移动后检查边界
        }

        // 触摸移动事件处理
        function onTouchMove(event) {
          if (event.touches.length === 1) {
            posX = startX - event.touches[0].clientX;
            posY = startY - event.touches[0].clientY;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            vnode.context.x -= posX;
            vnode.context.y -= posY;
            checkBounds(); // 每次移动后检查边界
          }
        }
        function onMouseUp() {
          document.onmousemove = null;
          document.onmouseup = null;
          setTimeout(()=>{
            vnode.context.moveMouser=false
          })
        }

        // 触摸结束事件处理
        function onTouchEnd() {
          document.ontouchmove = null;
          document.ontouchend = null;
        }
      },
    },
  },
  computed: {
    getUserName() {
      return  globalStorage.get_value('getUserParams','acc')
    },
    iframeSrc() {
      let link_obj=globalStorage.get_value('getUserParams','link')
      let url="https://proj6e-xiaoyush4-test-agent.txitech.com/dock/tx2/tx2/index"
      let query=''
      for (const key in link_obj) {
        if (key!=='login_url'){
          query+=key+"="+link_obj[key]+"&"
        }
      }
      query=query.slice(0, -1)
      return  url + "?" + query
    }
  },
  methods: {
    dialogTableShow(){
      console.log(this.moveMouser)
      if (!this.moveMouser){
        this.dialogTableVisible=true
      }
    },
    BindPhoneClick(type){
      this.bind_phone_open=type
    },
    BindRealNameClick(type){
      this.bind_real_open=type
    },
    BindPassClick(type){
      this.bind_pass_open=type
    },
    QuitClick(){
      //清楚登录信息 缓存
      window.localStorage.removeItem('userInfo')
      window.location.reload()

    },
    handleOpen() {
      this.updateDialogWidth();
      window.addEventListener('resize', this.updateDialogWidth);
    },
    handleClose() {
      window.removeEventListener('resize', this.updateDialogWidth);
    },
    SetUpQQ(){
      window.open('https://wpa.qq.com/msgrd?v=3&uin=2576095998&site=qq&menu=yes')
    },
    updateDialogWidth() {
      const screenWidth = window.innerWidth;
      if (screenWidth < 500) {
        this.dialogWidth = '80%';
      } else if (screenWidth < 600) {
        this.dialogWidth = '70%';
      } else if (screenWidth < 750) {
        this.dialogWidth = '60%';
      } else if (screenWidth < 910) {
        this.dialogWidth = '40%';
      } else if (screenWidth < 1150) {
        this.dialogWidth = '35%';
      } else if (screenWidth < 1477) {
        this.dialogWidth = '30%';
      } else if (screenWidth < 1700) {
        this.dialogWidth = '25%';
      } else {
        this.dialogWidth = '20%';
      }
    },
    handleMessage() {
      const iframeElement = this.$refs.myIframe;
      let report_params=this.$store.getters.getReportParams
      iframeElement.contentWindow.postMessage({ params: report_params }, "*");
      // 检查消息来源，确保安全
      // if (event.origin !== 'http://your-child-page-origin.com') {
      //   return;
      // }
      //
      // // 根据消息内容执行操作
      // if (event.data.type === 'loaded') {
      //   console.log('子页面已加载完成');
      //   // 这里可以执行更多操作，比如更新Vue数据等
      // }
    }
  },
  mounted() {
    this.y=Math.floor(window.innerHeight/2);
    let queryParam = this.$route.query||{}
    if (Reflect.has(queryParam,'username')&&Reflect.has(queryParam,'access_token')){
      this.showBall=false
    }
    window.addEventListener('message', this.handleMessage, false);
  }
};
</script>

<style scoped>
.iframe-container {

  height: 100vh;
  width: 100vw;
  overflow: scroll;
}
.iframe-container::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
/*.draggable {*/
/*  width: 100px;*/
/*  height: 100px;*/
/*  background-color: #42b983;*/
/*  color: white;*/
/*  display: flex;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  cursor: grab;*/
/*  user-select: none;*/
/*}*/
iframe {
  border: none; /* 移除 iframe 的边框 */
}
.btn_ball{
  padding:0 !important;
}
.close_btn{
  position: absolute;
  z-index: 9999;
  left: -8px;
  top: -13px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  transition: 0.5s ease;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}
.close_btn:before, .close_btn:after {
  position: absolute;
  top: 5px;
  left: 15px;
  content: " ";
  height: 20px;
  width: 1px;
  background-color: #908f8f;
}
.close_btn:before {
  transform: rotate(45deg);
}
.close_btn:after {
  transform: rotate(-45deg);
}
:after, :before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.row-bg_list{
  margin: 10px 0;
}
.custom-dialog >>>.el-dialog {
  padding: 0; /* 移除默认padding */
}

.custom-dialog >>>.el-dialog__body {
  position: relative;
  padding: 20px; /* 根据需要调整 */
  background: none; /* 移除默认背景 */
}

.custom-dialog>>>.el-dialog__body::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/login_bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.5; /* 根据需要调整透明度 */
  z-index: 0; /* 确保背景图片在内容下层 */
}
.custom-dialog>>>.el-dialog__header{
  padding: 0;
}
</style>
